import React from 'react'

interface ICheckboxProps extends React.HTMLProps<HTMLInputElement> {
  checked?: boolean
  onChange?: (e: React.FormEvent<HTMLInputElement>) => void
  disabled?: boolean
  label?: string
}

const Checkbox: React.FC<ICheckboxProps> = ({
  checked,
  onChange,
  label,
  ...rest
}) => {
  const [isFocusing, setIsFocusing] = React.useState<boolean>(false)

  return (
    <label
      className={`checkbox-container ${
        isFocusing ? 'checkbox-container-active' : ''
      }`}
    >
      {label && <p className='checkbox-label'>{label}</p>}
      <input
        type='checkbox'
        onFocus={() => setIsFocusing(true)}
        onBlur={() => setIsFocusing(false)}
        checked={checked}
        onChange={(e) => onChange && onChange(e)}
        {...rest}
      />
      <span className='checkbox-checkmark' />
    </label>
  )
}

export default Checkbox
